import { apiClient } from '@/libs/axios';
import {
  toCancelWithdrawalDTO,
  type CancelWithdrawalDTO,
} from '../schemas/cancel-withdrawal.schema';

export const cancelWithdrawal = async (
  id: number
): Promise<CancelWithdrawalDTO> => {
  const response = await apiClient.delete(`withdraw/${id}`);

  return toCancelWithdrawalDTO(response);
};
